import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { useApiClient } from '@/api/clients/useApiClient.util.ts';
import { QueryKeyEnum } from '@/api/model/QueryKey.enum.ts';
import { resetCurrentUser } from '@/contexts/userContext/util/fetchCurrentUser.util.ts';

type Response = void;

type Return = {
  isLoggingOut: boolean;
  logout: () => Promise<Response>;
};

export const useLogout = (): Return => {
  const { logoutApi } = useApiClient();
  const queryClient = useQueryClient();
  const { isPending, mutateAsync } = useMutation<Response, AxiosError>({
    mutationFn: async () => {
      await logoutApi.logout();
    },
    onSuccess: async () => {
      resetCurrentUser();
      await queryClient.refetchQueries({ queryKey: [QueryKeyEnum.USERS.CURRENT] });
    },
  });

  return {
    isLoggingOut: isPending,
    logout: mutateAsync,
  };
};
